<template>
  <div>
    <v-btn
      v-if="showButton"
      class="mt-2"
      elevation="0"
      small
      @click.native="showModal"
    >
      <v-icon small>account_circle</v-icon> Profile
    </v-btn>
    <avatar
      v-else
      class="room-avatar"
      clean
      :img="avatar"
      @click.native="showModal"
    />
  </div>
</template>

<script>
import Avatar from '@/components/basic/avatar/Avatar';
import { eventBus } from '@/lib/events';
import { mapState } from 'vuex';

export default {
  name: 'RoomAvatar',
  components: {
    Avatar,
  },
  props: {
    showButton: Boolean,
  },
  computed: {
    ...mapState('rooms', ['roomInfo']),
    avatar() {
      return this.roomInfo?.avatar;
    },
  },
  methods: {
    showModal() {
      eventBus.trigger('showRoomProfileModal');
    },
  },
};
</script>

<style lang="less">
.room-avatar {
  background: none !important;
}

.user-picture {
  height: 140px;
  width: 140px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  margin: 0 auto;
  svg,
  img {
    display: block;
    height: 140px;
    width: 140px;
    border-radius: 50%;
    margin: 0 auto;
    object-fit: cover;
  }

  svg {
    fill: #2c3e50;
  }
}
</style>
